var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.014,
    height: 14.014,
    viewBox: "0 0 14.014 14.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M13.891.574a.281.281,0,0,1,0,.465l-.6.6a.281.281,0,0,1-.465,0L9.516-1.668a.315.315,0,0,1-.109-.219V-2.27A5.519,5.519,0,0,1,5.688-.875a5.479,5.479,0,0,1-4.02-1.668A5.479,5.479,0,0,1,0-6.562a5.479,5.479,0,0,1,1.668-4.02,5.479,5.479,0,0,1,4.02-1.668,5.479,5.479,0,0,1,4.02,1.668,5.479,5.479,0,0,1,1.668,4.02A5.519,5.519,0,0,1,9.98-2.844h.383a.26.26,0,0,1,.219.109ZM2.6-3.473a4.213,4.213,0,0,0,3.09,1.285,4.213,4.213,0,0,0,3.09-1.285,4.213,4.213,0,0,0,1.285-3.09,4.213,4.213,0,0,0-1.285-3.09,4.213,4.213,0,0,0-3.09-1.285A4.213,4.213,0,0,0,2.6-9.652a4.213,4.213,0,0,0-1.285,3.09A4.213,4.213,0,0,0,2.6-3.473Z",
    transform: "translate(0 12.25)",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e32d67deb8f415b6a529cd5782b3558f.svg";
export { ForwardRef as ReactComponent };